import { useEffect, useCallback } from "react";

export default isPrenvent => {
  const preventReload = useCallback(event => {
    event.preventDefault();
    // eslint-disable-next-line no-param-reassign
    event.returnValue = "";
  }, []);

  useEffect(() => {
    if (isPrenvent) {
      window.addEventListener("beforeunload", preventReload);
    }
    return () => {
      if (isPrenvent) {
        window.removeEventListener("beforeunload", preventReload);
      }
    };
  }, [isPrenvent, preventReload]);
};
